import React, {
  useEffect,
  forwardRef,
  useState,
  useImperativeHandle,
} from 'react'
import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'

const Dialog = (
  { title, children, actions, onChange, actionsProps, ...props },
  ref,
) => {
  const [open, setOpen] = useState(false)

  const onClose = () => {
    setOpen(false)
    typeof props.onClose === 'function' && props.onClose()
  }

  const onOpen = () => {
    setOpen(true)
    typeof props.onOpen === 'function' && props.onOpen()
  }

  useEffect(() => {
    if (onChange) {
      onChange(open)
    }
  }, [onChange, open])

  useImperativeHandle(ref, () => ({
    open: onOpen,
    close: onClose,
    isOpen: open,
  }))

  return (
    <MuiDialog
      fullWidth
      aria-labelledby="dialog-title"
      {...props}
      onClose={onClose}
      open={open}
    >
      {title && <DialogTitle id="dialog-title">{title}</DialogTitle>}
      <DialogContent>{children}</DialogContent>
      {actions && <DialogActions {...actionsProps}>{actions}</DialogActions>}
    </MuiDialog>
  )
}

export default forwardRef(Dialog)
